export const FILE_ACCEPTED_TYPES = ".xlsx,.xls";
export const MAX_FILE_SIZE_MB = 25;

export const ACCEPTED_MIME_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];

export const FILE_ACCEPTED_TYPES_WITH_CSV = ".xlsx,.xls,.csv";

export const ACCEPTED_MIME_TYPES_WITH_CSV = [
  ...ACCEPTED_MIME_TYPES,
  "text/csv",
];
